import PropTypes from 'prop-types';
import React from 'react';
import StockOrb from './StockOrb';
import styled from 'react-emotion';

const StockStatusWrapper = styled('p')`
  margin-top: 16px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
`;

function allEqual(arr) {
  if (!arr.length) return true;
  return (
    arr.reduce(function(a, b) {
      return a === b ? a : !b;
    }) === arr[0]
  );
}

const StockStatusIndicator = ({ status, text, variants }) => {
  if (variants.values.length > 0) {
    var variantTexts = [];
    for (let i = 0; i < variants.values.length; i++) {
      const variant = variants.values[i];
      variantTexts.push(variant.stockStatus.text);
    }
  }

  return (
    <StockStatusWrapper css={{}}>
      <StockOrb status={status} />
      {variants.values.length > 0 && variantTexts && allEqual(variantTexts) ? (
        <span>{variantTexts[0]}</span>
      ) : (
        <span>{text}</span>
      )}
    </StockStatusWrapper>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string
};

export default StockStatusIndicator;
